'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (form) {
  var o = {};
  var a = form.serializeArray();

  $.each(a, function () {
    if (o[this.name]) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });

  return o;
};


// WEBPACK FOOTER //
// ./scripts/util/serializeForm.js